<script>
  import {tick} from "svelte"
	export let title = '';
	let isHovered = false;
	let x;
	let y;
  let tooltip;

  const sleep = (time) => new Promise(resolve => setTimeout(resolve, time))

	async function mouseOver(event) {
		y = 10;
    positionTooltip()
		isHovered = true;
	}
	function mouseLeave() {
		isHovered = false;
	}

  function positionTooltip(){
    var containerBounds = tooltip.parentNode.parentNode.getBoundingClientRect()
    let tooltipBounds = tooltip.getBoundingClientRect();

    if(tooltipBounds.left < containerBounds.left){
      x = containerBounds.left - tooltipBounds.left
    }else{
      x = 5
    }
  }
</script>

<div
  style="width:10px;height:10px; position:absolute; top:0; left:0"
	on:mouseover={mouseOver}
  on:mouseleave={mouseLeave}>
  <slot name="tooltip"></slot>
</div>

<div bind:this={tooltip} style="left: {x}px;" class="tooltip" class:isHovered>
  <slot name="hover"></slot>
</div>


<style type="text/scss">
	.tooltip {
    background: #1f2a37;
    color:white;
		border-radius: 4px;
    padding: 10px 10px;
		position: absolute;
    pointer-events: none;
    opacity: 0;
    bottom: calc(100% + 5px);
    left: 50%;
    transform: translate(-50%);
    min-width:150px;

    &.isHovered {
      display:block;
      opacity: 1;
    }
	}
</style>
